import { render, staticRenderFns } from "./SupportFAQDetail.vue?vue&type=template&id=d8124b9c"
import script from "./SupportFAQDetail.vue?vue&type=script&lang=js"
export * from "./SupportFAQDetail.vue?vue&type=script&lang=js"
import style0 from "./SupportFAQDetail.vue?vue&type=style&index=0&id=d8124b9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports